import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import DialogTitle from '@/components/DialogTitle';

/**
 * プロパティ
 */
export type Props = {
  /** 取り消し */
  action: () => void,
  /**
   * 閉じる
   * @returns なし
   */
  cancel: () => void,
};

const ConfirmDelete: React.FC<Props> = ({
  action,
  cancel,
}) => (
  <Dialog
    open
    onClose={() => cancel()}
  >
    <DialogTitle title="確認" />
    <DialogContent>
      <p>削除してよろしいですか？</p>
    </DialogContent>
    <DialogActions>
      <Button
        variant="contained"
        onClick={() => action()}
        color="primary"
        startIcon={<DeleteIcon />}
      >
        削除
      </Button>
      <Button variant="contained" onClick={() => cancel()} color="primary">
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDelete;
